import { EventDoc } from 'types/api/changes'
import { CurrentConvertedCalendars } from './google_events'
import { icloudPrefix } from './constants'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import { ICalendar } from 'types/google_events'

export function thirdPartyCalendarIdToPrimaryEmail(id: string): string {
  return (
    CurrentConvertedCalendars.find((calendar) => calendar.id === id)
      ?.primaryCalendarEmail || ''
  )
}

export function isIcloudEvent(event: EventDoc) {
  return (
    CurrentConvertedCalendars.find(
      (calendar) => calendar.localId === event.GroupID
    )?.prefix === icloudPrefix
  )
}

export function cacheConvertedCalendarsToLocalStorage() {
  if (CurrentConvertedCalendars.length === 0) return

  LocalStorage.set(
    LocalStorageKey.CACHED_CONVERTED_CALENDARS,
    JSON.stringify(CurrentConvertedCalendars)
  )
}

export function getCachedConvertedCalendarsFromLocalStorage(): ICalendar[] {
  const cached = LocalStorage.get(LocalStorageKey.CACHED_CONVERTED_CALENDARS)
  const inMemory = CurrentConvertedCalendars

  return cached ? JSON.parse(cached) : inMemory
}
